import React, { useEffect, useState } from 'react';
import '../styles/PosterSlideshow.css';

const PosterSlideshow = ({ posters, autoplaySpeed = 10000, onClick }) => {
    const [currentIndex, setCurrentIndex] = useState(0);
    const [imageErrors, setImageErrors] = useState({});

    const handleImageError = (index) => {
        setImageErrors(prev => ({ ...prev, [index]: true }));
        console.error(`Failed to load campaign image at index ${index}:`, posters[index]?.imageUrl);
    };

    useEffect(() => {
        if (posters && posters.length > 1) {
            const interval = setInterval(() => {
                setCurrentIndex((prevIndex) => (prevIndex + 1) % posters.length);
            }, autoplaySpeed);

            return () => clearInterval(interval);
        }
    }, [posters, autoplaySpeed]);

    const handleNext = () => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % posters.length);
    };

    const handlePrev = () => {
        setCurrentIndex((prevIndex) => (prevIndex - 1 + posters.length) % posters.length);
    };

    const handleIndicatorClick = (index) => {
        setCurrentIndex(index);
    };

    const handlePosterClick = () => {
        if (onClick) {
            const currentPoster = posters[currentIndex];
            onClick(currentPoster.link, currentPoster);
        }
    };

    if (!posters || posters.length === 0) {
        return null;
    }

    return (
        <div className="dashboard-slideshow">
            <div className="slideshow-container">
                {posters.map((poster, index) => (
                    <div
                        key={index}
                        className={`poster ${index === currentIndex ? 'active' : ''}`}
                        onClick={handlePosterClick}
                        style={{ cursor: onClick && poster.link ? 'pointer' : 'default' }}
                    >
                        <img
                            src={poster.imageUrl || poster}
                            srcSet={poster.srcSet || null}
                            sizes="(max-width: 576px) 100vw, 
                                   (max-width: 768px) 100vw, 
                                   (max-width: 1200px) 100vw, 
                                   100vw"
                            alt={poster.alt || `Poster ${index + 1}`}
                            loading="lazy"
                            className={`poster-image ${poster.mobilePosition ? `mobile-position-${poster.mobilePosition}` : ''}`}
                            onError={() => handleImageError(index)}
                            style={{ display: imageErrors[index] ? 'none' : 'block' }}
                        />
                        {/* Product Price Top Right */}
                        {poster.price && poster.currency && (
                            <div className="poster-product-price">
                                {poster.currency} {poster.price}
                            </div>
                        )}
                        {imageErrors[index] && (
                            <div className="poster-error-placeholder">
                                <div className="error-content">
                                    <span>📷</span>
                                    <p>Image non disponible</p>
                                </div>
                            </div>
                        )}
                        {poster.caption && (
                            <div className="poster-caption">
                                <h3>{poster.caption.title}</h3>
                                <p>{poster.caption.text}</p>
                            </div>
                        )}
                    </div>
                ))}
            </div>

            {posters.length > 1 && (
                <>
                    <button
                        className="navigation-button left"
                        onClick={handlePrev}
                        aria-label="Previous slide"
                    >
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M15 18L9 12L15 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                    </button>
                    <button
                        className="navigation-button right"
                        onClick={handleNext}
                        aria-label="Next slide"
                    >
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M9 18L15 12L9 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                    </button>

                    <div className="indicators">
                        {posters.map((_, index) => (
                            <div
                                key={index}
                                className={`indicator ${index === currentIndex ? 'active' : ''}`}
                                onClick={() => handleIndicatorClick(index)}
                                aria-label={`Go to slide ${index + 1}`}
                            />
                        ))}
                    </div>
                </>
            )}
        </div>
    );
};

export default PosterSlideshow;